import { Box, IconButton } from '@chakra-ui/react';
import { MdMoreVert } from 'react-icons/md';

import { ScanningTotal } from '@app/api/models';
import { TableColumn } from '@app/components/common/table';
import { Txt } from '@app/components/common';
import { Level } from '@app/api/models/structure';

import { ScanningNodeItem } from './types';
import { EquipScanningReportViewNode } from './components/node';

export const useColumns = ({ chain, levels, onItemClick, onMoveUpClick, onShowDetail }: { 
  chain: ScanningNodeItem[],
  levels: Level[],
  onItemClick: (item: ScanningNodeItem) => void
  onMoveUpClick: (item: ScanningNodeItem) => void
  onShowDetail: (item: ScanningNodeItem) => void
}): TableColumn<ScanningNodeItem>[] => {
  return [
    {
      name: 'id',
      label: '#',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (name, { rowData, totalRows, rowIndex }) => {
          if (rowData.id === '-1') {
            return <Txt color='gray.500'>Итого</Txt>;
          }
          if (!chain.length) {
            return <EquipScanningReportViewNode
              data={rowData}
              isLastLevel={false}
              index={0}
              parentIndex={0}
              onItemClick={onItemClick}
            />;
          }
          const index = chain.findIndex(({ id, level }) => id === rowData.id && level.id === rowData.level.id);
          const isLastLevel = levels[levels.length - 1].value === rowData.level.id;
          const levelIndex = levels.findIndex(({ value }) => value === rowData.level.id);

          if (index !== -1) {
            const parentLevelIndex = index > 0 ? levels.findIndex(({ value }) => value === chain[index - 1].level.id) : -1; 

            return <EquipScanningReportViewNode               
              data={rowData}
              isLastLevel={false}
              index={levelIndex}
              parentIndex={parentLevelIndex}
              onItemClick={onMoveUpClick}
              linkUp={index > 0 ? 1 : undefined}
              linkDown
            />;
          }
          const parentLevelIndex = levels.findIndex(({ value }) => value === chain[chain.length - 1].level.id);  

          return <EquipScanningReportViewNode
            data={rowData}
            index={levelIndex}
            parentIndex={parentLevelIndex}
            isLastLevel={isLastLevel}
            onItemClick={onItemClick}
            linkUp={1}
            linkMore={totalRows > rowIndex + 2} 
          />;
        },
      },
    },
    {
      name: 'total',
      label: 'Сканирование',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: ScanningTotal) =>  {
          return <Box display='flex' alignItems='center' justifyContent='flex-start'>
            <Txt fontWeight='bold'>{value.scanning}</Txt>
          </Box>;
        },
      },
    },
    {
      name: 'total',
      label: '',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: ScanningTotal, { rowData }) =>  {
          if (rowData.id === '-1') {return null;}
          return <Box display='flex' alignItems='center'>
            <Box ml={1}>
              <IconButton aria-label='' onClick={() => onShowDetail(rowData)}>
                <MdMoreVert />
              </IconButton>
            </Box>
          </Box>;
        },
      },
    },
    // filters
    {
      name: 'user',
      label: 'Имя пользователя',
      options: {
        hidden: true,
        filter: {
          type: 'text',
          name: 'user',
        },
        sort: false,
      },
    },
    {
      name: 'full_name',
      label: 'Пользователь',
      options: {
        hidden: true,
        filter: {
          type: 'text',
          name: 'full_name',
        },
        sort: false,
      },
    },
    {
      name: 'serial_num',
      label: 'Серийный номер',
      options: {
        hidden: true,
        filter: {
          name: 'serial_num',
          type: 'text',
          isApplied: true,
        },
        sort: false,
      },
    },
    {
      name: 'inventory_num',
      label: 'Инв.номер',
      options: {
        hidden: true,
        filter: {
          type: 'text',
          name: 'inventory_num',
        },
        sort: false,
      }
    },
    {
      name: 'model',
      label: 'Модель',
      options: { 
        hidden: true,
        filter: {
          type: 'multi-select',
          name: 'model',
          sourceName: 'equipment_model',
        },
        sort: false,
      }
    },
    {
      name: 'brand',
      label: 'Бренд', 
      options: {
        hidden: true,
        filter: {
          type: 'multi-select',
          name: 'brand_id',
          sourceName: 'equipment_brand',
        },
        sort: false,
      }
    },
    {
      name: 'manufacturer',
      label: 'Производитель',
      options: {
        hidden: true,
        filter: {
          type: 'multi-select',
          name: 'manufacturer_id',
          sourceName: 'equipment_manufacturer',
        },
        sort: false, 
      }
    }
  ];
};